import Sellers from './Sellers.page';

export default Sellers;
